module.exports = __webpack_public_path__ + "img/3_74.4aeb2f2e.png";